import { atom } from 'jotai';
import { $CurrentAvailableArticleOrNull } from '@article/shared/atoms/current-article';
import { ArticleDetailUtil } from 'shared/models';
import { $Locale, $RootTraffic } from '@lemon8/web-app-shared/atom';
import { Region } from '@lemon8/web-app-shared/i18n';

export const $CurrentArticleCanonical = atom((get) => {
  const article = get($CurrentAvailableArticleOrNull);
  const { region } = get($Locale);
  const { enterHref: href } = get($RootTraffic);

  if (!article) {
    return null;
  }

  const url = new URL(href);

  const translatedArticleToShow = ArticleDetailUtil.isTranslatedArticleToShow(article, region);

  const canonicalRegion = translatedArticleToShow ? Region.us : article.articleRegion;

  return `${url.protocol}//${url.host}/${article.author.linkName}/${article.groupId}?region=${canonicalRegion}`;
});
